import type { ItemCounterConfig } from './item-counter'
import { type DisplayMode, items, type LineItem, type LineItemSection, type Slip, visibleSections } from './slips'

export type ItemAction = 'start' | 'finish' | 'clear'
export function canPrepare(section: LineItemSection, item: LineItem, displayId: string): boolean {
  return !section.isSecondary && (!item.preparationBy || item.preparationBy.id === displayId)
}
export function nextItemAction(item: LineItem, skipStart: boolean): ItemAction {
  if (item.preparationCompletedAt) return 'clear'
  return item.preparationStartedAt || skipStart ? 'finish' : 'start'
}
export function remainingItems(slip: Slip, displayId: string, mode: Exclude<DisplayMode, 'auto'>, config: ItemCounterConfig): number {
  return visibleSections(slip, mode).flatMap((section) =>
    items(section).filter(
      (item) => canPrepare(section, item, displayId) && !item.preparationCompletedAt && !(displayId === 'main' && config.enabled && config.autoCompleteProductNames.includes(item.name ?? '')),
    ),
  ).length
}
export function itemSlipState(slip: Slip, mode: Exclude<DisplayMode, 'auto'>) {
  if (slip.readyForPickup) return 'ready'
  const lines = visibleSections(slip, mode).flatMap(items)
  if (lines.length && lines.every((item) => item.preparationCompletedAt)) return 'done'
  return lines.some((item) => item.preparationStartedAt) ? 'preparing' : 'waiting'
}
